module.exports = __webpack_public_path__ + "static/media/12.37b90677.jpg";